import { SxProps, Theme } from "@mui/material";

export interface iButtonProps {
	buttonText?: string | React.ReactNode;
	variant?: BUTTON_VARIANT;
	color?: BUTTON_COLOR;
	fullWidth?: boolean;
	disabled?: boolean;
	coreBtnPill?: boolean;
	onclick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
	uploadFileIcon?: React.ReactNode;
	onfileSelect?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	showFileInput?: boolean;
	className?: string;
	loading?: boolean;
	startIcon?: React.ReactNode;
	onMouseOver?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
	onMouseOut?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
	onMouseMove?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
	onMouseUp?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
	onMouseDown?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
	onMouseClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
	onMouseDoubleClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
	onMouseWheel?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
	onMouseContextMenu?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
	onMouseEnter?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
	onMouseLeave?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
	sx?: SxProps<Theme>;
}

export enum BUTTON_VARIANT {
	TEXT = "text",
	OUTLINED = "outlined",
	CONTAINED = "contained",
}

export enum BUTTON_COLOR {
	INHERIT = "inherit",
	PRIMARY = "primary",
	SECONDARY = "secondary",
	ERROR = "error",
	WARNING = "warning",
}
